export default {
  label: '销售主管',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '销售主管负责带领销售团队，制定销售计划，完成销售任务',
          id: '0-1-1',
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定并实施销售计划，完成销售目标',
          id: '0-2-1',
        },
        {
          label: '带领销售团队，监督销售活动，确保目标达成',
          id: '0-2-2',
        },
        {
          label: '分析市场动态，制定市场策略，推动销售增长',
          id: '0-2-3',
        },
        {
          label: '维护客户关系，开发新客户，拓展销售渠道',
          id: '0-2-4',
        },
        {
          label: '培训下属，提升团队整体素质',
          id: '0-2-5',
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '大专以上学历，3年以上销售经验',
          id: '0-3-1',
        },
        {
          label: '强大的市场感知能力，敏锐的市场洞察力',
          id: '0-3-2',
        },
        {
          label: '良好的沟通能力、组织协调能力和团队合作精神',
          id: '0-3-3',
        }
      ]
    }
  ]
}